import closeIcon from "../assets/newCloseIcon.png";

const CloseModalIcon = () => {
  return (
    <img src={closeIcon} alt="" width={12} height={12} />
  )
}

export default CloseModalIcon;
